import { ComponentsReducers } from "@insite/client-framework/Store/Components/ComponentsReducer";
import { DataReducers } from "@insite/client-framework/Store/Data/DataReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import dataReducer from "@store/Store/Data/DataReducer";
import DataState from "@store/Store/Data/DataState";
import pagesReducer, { PagesReducers } from "@store/Store/Pages/PagesReducer";
import PagesState from "@store/Store/Pages/PagesState";
import { combineReducers } from "redux";

export interface StoreState {
    readonly pages: PagesState;
    readonly data: DataState;
}

const storeReducers = {
    pages: pagesReducer,
    data: dataReducer,
};

const storeReducer = combineReducers(storeReducers as any);
(reducers as any).store = combineReducers(storeReducers);

type Reducers = Omit<typeof storeReducers, "pages">;
export type StoreAction =
    | AnyAction
    | Parameters<Reducers[keyof Reducers]>[1]
    | Parameters<PagesReducers[keyof PagesReducers]>[1]
    | Parameters<ComponentsReducers[keyof ComponentsReducers]>[1]
    | Parameters<DataReducers[keyof DataReducers]>[1];

export type StoreActions = Parameters<DataReducers[keyof DataReducers]>[1] | AnyAction;

export default storeReducer;
